import { useState } from "react";
import { parseDocumentQr } from "../utils/scanDocumentQrParser";
import { checkDni } from "../shared/ManualSearchForm/ManualSearchForm";
import { useStore } from "./useStore";

export interface DocumentQrResult {
  dni: string;
  country: string;
  sex?: string;
  birthdate?: string;
  firstname?: string;
  lastname?: string;
}

const useScanDocumentQr = () => {
  const { authStore } = useStore();
  const [resultDocumentQr, setResultDocumentQr] = useState<DocumentQrResult | null>(null);

  const scanDocumentQr = (value: string) => {
    const parsed = parseDocumentQr(value);
    if (!parsed || !checkDni(parsed.dni)) return;
    const country: any = authStore.country;
    setResultDocumentQr({
      dni: parsed.dni,
      country: parsed.country || country?.code || "ARG",
      sex: parsed.sex,
      birthdate: parsed.birthdate,
      firstname: parsed.firstname,
      lastname: parsed.lastname,
    });
  };

  const resetDocumentQr = () => {
    setResultDocumentQr(null);
  };

  return { scanDocumentQr, resultDocumentQr, resetDocumentQr };
};

export default useScanDocumentQr;
